// extracted by mini-css-extract-plugin
export default {"title":"title__A1OHX","buttonsContainer":"buttonsContainer__BH2aN","button":"button__lUZ6Z","noButton":"noButton__l0bt1","yesButton":"yesButton__1e9B4"};